module.exports = __webpack_public_path__ + "static/media/sla_logo.b95df9a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Masthead/sla_logo.svg
// module id = 292
// module chunks = 0